import type { PropsWithChildren } from 'react';
import React from 'react';

export const connectHook = <OwnProps, ContainerProps>(
  Component: React.ComponentType<OwnProps & ContainerProps>,
  hook: (props: OwnProps) => ContainerProps
) => {
  const MemoizedComponent = React.memo(Component) as React.ComponentType<OwnProps & ContainerProps>;

  function Connected(props: PropsWithChildren<OwnProps>) {
    return <MemoizedComponent {...props} {...hook(props)} />;
  }

  const originalName = Component.displayName ?? Component.name ?? 'Component';
  Connected.displayName = `ConnectHook(${originalName})`;
  return Connected;
};
